<div class="container"
     [style.width.px]="windowService.isMobileDevice() ? 260 : 360"
     [class.desktop]="!windowService.isMobileDevice()">
  <div class="title" *ngIf="!data.hideTitle"
       [innerHTML]="data.title | newLineToHtml | safeHTML"></div>
  <div class="max-content"
       [class.margin-top]="data.hideTitle">
    <div class="sub-title" *ngIf="data.subTitle">{{data.subTitle}}</div>
    <div class="center-container">
      <div class="content" *ngIf="data.content"
           [class.warn]="data.warnText"
           [class.light]="!data.warnText && !data.hideTitle"
           [class.large-text]="data.hideTitle"
           [innerHtml]="data.content | newLineToHtml | safeHTML">
      </div>
    </div>
    <ng-container *ngIf="data.template" [ngTemplateOutlet]="data.template"></ng-container>
  </div>
  <div class="submit-button-container" *ngIf="data.singleBtnTitle">
    <button type="button" appFocusRemove (click)="onClick(true)">{{data.singleBtnTitle}}</button>
  </div>
  <div class="submit-button-container" *ngIf="data.leftBtnTitle && data.rightBtnTitle">
    <button type="button" appFocusRemove (click)="onClick(false)">{{data.leftBtnTitle}}</button>
    <button type="button" appFocusRemove (click)="onClick(true)">{{data.rightBtnTitle}}</button>
  </div>
</div>
